// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"13ba26f3","191":"d5af223b","246":"fa8ce9ea","342":"b170673e","647":"a9052850"}[chunkId] + ".chunk.js";
};